import ApprovalRow from './ApprovalRow';
import { Signatory } from './hidotOvertimeReportUtilities';

import classes from './hidotOvertimeReport.module.css';

type ApprovalGroupProps = {
  title: string;
  signatories: Signatory[];
};

const ApprovalGroup = ({ title, signatories }: ApprovalGroupProps) => {
  return (
    <>
      <div className={classes.approvalGroupHeader}>
        <div className={classes.approvalCell}>{title}</div>
        <div className={classes.approvalCell}>Signature</div>
        <div className={classes.approvalCell}>Date</div>
      </div>
      {signatories.map(signatory => (
        <ApprovalRow
          key={`${title}-${signatory.name}-${signatory.title}`}
          signatory={signatory}
        />
      ))}
    </>
  );
};

export default ApprovalGroup;
